var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.03 217.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#000;stroke-miterlimit:10;stroke-width:2.35px;}.cls-2{fill:#da00c6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.65,143a82.15,82.15,0,1,1,30.59,18.52L5.88,212.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40,68.22a17.22,17.22,0,0,1,8.12-11c10.07-6,23.15-1.89,28.95,8.27l2.75,4.81,2.75-4.81c5.8-10.16,18.88-14.23,29-8.27a17.19,17.19,0,0,1,8.12,11c4.47,17.89-35.65,57-39.65,60.84v.33l-.17-.17-.17.17v-.33C75.6,125.22,35.48,86.11,40,68.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart1);
export default __webpack_public_path__ + "static/media/heart1.33fcba3a3c816ffb4d4bc64658bc10e1.svg";
export { ForwardRef as ReactComponent };